<template>
  <el-dialog
    title="分销设置"
    :visible.sync="showDialog"
    :append-to-body="true"
    width="40%"
  >
    <el-alert
      style="padding:10px;"
      title="提示"
      type="warning"
      :closable="false"
    >
      <div>
        1.两级分销价格必须同时设置。<br>
        2.会员组售价不会产生分销收益<br>
        3.如果分销金额大于售价的一半，该分销视为无效，该笔订单也不会产生分销分成。<br>
      </div>
    </el-alert>
    <div class="fx-main">
      <div class="item">
        <div class="title">一级分销:</div>
        <el-input placeholder="请输入分成金额" v-model="distributionInfo.level_one" size="small">
          <template slot="append">
            <el-select v-model="distributionInfo.level_one_type" style="width: 70px" placeholder="请选择">
              <el-option key="1" label="元" :value="1"/>
              <el-option key="2" label="%" :value="2"/>
            </el-select>
          </template>
        </el-input>
      </div>
      <div class="item">
        <div class="title">二级分销:</div>
        <el-input placeholder="请输入分成金额" v-model="distributionInfo.level_two" size="small">
          <template slot="append">
            <el-select v-model="distributionInfo.level_two_type" style="width: 70px" placeholder="请选择">
              <el-option key="3" label="元" :value="1"/>
              <el-option key="4" label="%" :value="2"/>
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideFx">取 消</el-button>
      <el-button type="primary" :loading="distributionLoading" @click="setDistributionPrice">确
        定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "i-fenxiao",
  props: {
    productId: {
      Type: String,
    },
    show: {
      Type: Boolean,
      default: false
    },
    value: {},
    input: {},
  },
  data: function () {
    return {
      distributionLoading: false,
      showDialog: false,
      distributionInfo: {
        level_one: '',
        level_two: '',
        level_one_type: '1',
        level_two_type: '1',
      }
    }
  },
  methods: {
    getDistribution: function () {
      this.dialogVisible = true;
      this.$http.request('getDistributionPrice', {product_id: this.productId}).then((res) => {
        this.distributionInfo = res.data;
      });
    },
    setDistributionPrice: function () {
      this.distributionLoading = true;
      this.distributionInfo.product_id = this.productId;
      this.$http.request('setDistributionPrice', this.distributionInfo).then((res) => {
        let _self = this;
        if (res.status === 'success') {
          this.$message({
            message: res.message, type: 'success', onClose: function () {
              _self.hideFx();
              _self.distributionLoading = false;
            }
          });
        }
      });
    },
    hideFx: function () {
      this.showDialog = false;
    }
  },
  created: function () {
    this.getDistribution();
    this.showDialog = this.show;
  },
  watch: {
    show: function () {
      this.showDialog = this.show;
    },
    productId: function () {
      this.getDistribution();
    },
    showDialog: function () {
      this.$emit('change', this.showDialog);
    }
  }
}
</script>

<style scoped lang="less">
.fx-main {
  width: 100%;
  display: flex;
}

.item {
  flex-grow: 1;
  margin: 10px;
}

.item .title {
  font-size: @normal-text-font-size;
  color: @main-text-color;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/i-fenxiao.vue